<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card flat tile class="mx-auto overflow-hidden accent" min-height="calc(100vh - 112px)">
            <v-card flat tile class="primary">  
                <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content>
                            <file-pond
                                name="filepond"
                                ref="filepond"
                                label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                v-bind:allow-multiple="true"
                                v-bind:allowImagePreview="false"
                                :server="{
                                    url: 'https://api.mrpoolal.com/api/crm/at/file?id='+id,
                                    process: {
                                        headers: {
                                            'Authorization': `Bearer ${token}`
                                        }
                                    }
                                }"
                                v-bind:files="files"
                                v-on:init="handleFilePondInit"
                                v-on:processfile="handleFilePondProcessfile"
                                class="mb-0"
                                />
                        </v-list-item-content>
                    </v-list-item>
                </v-list>            
            </v-card>
            <template>
                <v-card flat tile class="mx-auto overflow-hidden">
                    <v-data-table
                        :headers="headers"
                        :items="form.files"
                        class="elevation-0"
                        item-key="id"
                        :loading="loading"
                        >
                        <template v-slot:item.actions="{ item }">
                            <v-btn small depressed color="secondary" tile :href='`https://api.mrpoolal.com/storage/uploads/files/${item.file}`' target="_blank">
                                <v-icon
                                    color="white"
                                    small
                                    >
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                            <v-btn small depressed color="primary" tile @click="deleteItem(item)">
                                <v-icon
                                    small
                                    >
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.file_name="props">
                            <a :href="`https://api.mrpoolal.com/storage/uploads/files/${props.item.file}`" target="_blank">{{ props.item.file_name }}</a>
                        </template>
                    </v-data-table>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card color="red">
                            <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
                            <v-card-actions class="red darken-4">
                                <v-spacer></v-spacer>
                                <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
                                <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
            </template>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import TokenService from '../../services/storage.service'

    export default {
        props: ['id'],
        data () {
            return {
                loading: false,
                token: '',
                pageTitle: '',
                drawer: false,
                files: [],
                form: {
                    files: []
                },
                uploadedFiles: [],
                headers: [
                    { text: 'File Name', value: 'file_name', sortable: false },
                    { text: 'Created At', value: 'created_at', sortable: false },
                    { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
                ],
                dialogDelete: false,
                editedItem: {
                    id: '',
                },
                defaultItem: {
                    id: '',
                },
            }
        },
        created() {
            this.getFiles()
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        computed: {

        },
        methods: {
            getFiles() {
                if(this.id) {
                    this.loading = true
                    axios.get('crm/at/files?id=' + this.id)
                        .then((response) => {
                            this.loading = false
                            this.form.files = response.data.files
                            this.$nextTick()
                        })
                }
            },
	        handleFilePondProcessfile: function () {
	            this.getFiles();
	            this.$nextTick()
	        },
	        handleFilePondRevertfile: function () {
	            this.getFiles();
	            this.$nextTick()
	        },
	        deleteItem (item) {
	            this.editedItem = Object.assign({}, item)
	            this.dialogDelete = true
	        },
	        deleteItemConfirm () {
	            this.loading = true
	            axios.delete('crm/at/delete_file_by_id?id=' + this.editedItem.id)
	                .then(() => {
	                    this.closeDelete()
	                    this.getFiles()
	                    this.$nextTick()
	                })
	        },
	        closeDelete () {
	            this.dialogDelete = false
	            this.$nextTick(() => {
	                this.editedItem = Object.assign({}, this.defaultItem)
	            })
	        },
        }
    }
</script>

<style lang="sass">
.filepond--panel-center
    &.filepond--panel-root
        outline: none!important
#imgId
    display: none
figure.gallery-thumbnail
    text-align: center
</style>